import TextButton from '../../common/component/TextButton';

interface IProps {
  text: string;
}

export default function MoreItemBtn({text}: IProps) {
  return (
    // TODO : V4 다크모드 디자인이 아직 나오지 않았음. 현재는 기존 디자인 그대로 적용
    <TextButton
      className="bg-grey-14 h-28 rounded-25 light:bg-grey-12"
      textClassName="s12-medium-black light:text-white"
    >
      {text}
    </TextButton>
  );
}
